// Port of api/fuel/app/classes/insights/player/counts.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'

export default Segment.extend({
	name: 'counts',
	types: [Constants.TYPE_USER],
	insight: false,
	detail: false,
	run: function() {
		var counts = {}
		var playKeys = Object.keys(this._data.plays || {})
		for (var i = 0; i < playKeys.length; i++) {
			var play = this._data.plays[playKeys[i]]
			if (!counts[play.pl]) counts[play.pl] = 0
			counts[play.pl] += play.c
		}
		return {
			counts: counts
		}
	}
})
